// extracted by mini-css-extract-plugin
module.exports = {"PopIn":"styles_PopIn__rwy7e","PopinCloseIcon":"styles_PopinCloseIcon__rk1ff","PopinPrevIcon":"styles_PopinPrevIcon__iBYg5"};